<template>
    <div>
        <table>
            <tr>
                <td>仕様を選択する</td>
                <td>
                    <b-form-select v-model="kurumi_selected"
                                   :options="$store.state.xlsx_select_data.select_data['ベッドスプレッド'][$store.state.step2_data.style_selected2_name]['仕様を選択する'].option"></b-form-select>

                </td>
            </tr>
            <tr>
                <td>スタンダード/キルティング</td>
                <td>
                    <b-form-select v-model="quilting_type"
                                   :options="$store.state.xlsx_select_data.select_data['ベッドスプレッド'][$store.state.step2_data.style_selected2_name]['スタンダード/キルティング'].option"></b-form-select>

                </td>
            </tr>
            <tr>
                <td>仕上りサイズを選択する</td>
                <td>
                    <b-form-select v-model="bed_size"
                                   :options="bed_options"></b-form-select>

                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'bed_spread',
        data : function(){
            return {
            }
        },
        created : function(){
            if(this.kurumi_selected === ''){
                this.kurumi_selected = this.$store.state.xlsx_select_data.select_data['ベッドスプレッド'][this.$store.state.step2_data.style_selected2_name]['仕様を選択する'].option[0].value
            }
            if(this.bed_size === ''){
                this.bed_size = this.$store.state.xlsx_select_data.select_data['ベッドスプレッド']['くるみ無し']['仕上りサイズを選択する'].option[0].value
            }
            if(this.quilting_type === ''){
                this.quilting_type = this.$store.state.xlsx_select_data.select_data['ベッドスプレッド'][this.$store.state.step2_data.style_selected2_name]['スタンダード/キルティング'].option[0].value
            }
        },
        watch: {
            style_selected2_name:function(value){
                if(this.kurumi_selected === ''){
                    this.kurumi_selected = this.$store.state.xlsx_select_data.select_data['ベッドスプレッド'][this.$store.state.step2_data.style_selected2_name]['仕様を選択する'].option[0].value
                }
                if(this.bed_size === ''){
                    this.bed_size = this.$store.state.xlsx_select_data.select_data['ベッドスプレッド']['くるみ無し']['仕上りサイズを選択する'].option[0].value
                }
                if(this.quilting_type === ''){
                    this.quilting_type = this.$store.state.xlsx_select_data.select_data['ベッドスプレッド'][this.$store.state.step2_data.style_selected2_name]['スタンダード/キルティング'].option[0].value
                }
            }
        },
        computed: {
            bed_options:{
                get:function(){
                    if(this.$store.state.step3_data.kurumi ==='' || this.$store.state.step3_data.kurumi ==='くるみ無し'){
                        return this.$store.state.xlsx_select_data.select_data['ベッドスプレッド']['くるみ無し']['仕上りサイズを選択する'].option
                    }
                    else{
                        return this.$store.state.xlsx_select_data.select_data['ベッドスプレッド']['くるみ有り']['仕上りサイズを選択する'].option
                    }
                }
            },
            kurumi_selected: {
                get: function () {
                    return this.$store.state.step3_data.kurumi
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'kurumi', value:value})
                }
            },
            bed_size: {
                get: function () {
                    return this.$store.state.step3_data.bed_size
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'width_size', value:200})
                    this.$store.commit('updateOptionSelected', {name:'bed_size', value:value})
                }
            },
            quilting_type: {
                get: function () {
                    return this.$store.state.step3_data.quilting_type
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'height_size', value:200})
                    this.$store.commit('updateOptionSelected', {name:'quilting_type', value:value})
                }
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            },
            style_selected2_id: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_id
                },
            },
        },
    }
</script>

<style scoped>

</style>